import { styled, Typography } from "@material-ui/core";

export const HeaderBoxContainer = styled("div")(({ theme }) => ({
  maxWidth: "33%",
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  flexDirection: "column",
  justifyContent: "center",
  display: "flex",
  width: "100%",
}));

export const HeaderBoxContent = styled("div")(({ theme }) => ({
  borderBottom: "1px solid #FFF",
  borderTop: "1px solid #FFF",
  paddingBottom: theme.spacing(0.5),
  width: "100%",
  flexGrow: 1,
}));

export const HeaderBoxTitle = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.primary.main,
}));



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/HeaderBox/HeaderBox.styles.js